module.exports = __webpack_public_path__ + "img/playaBets.0103155c.png";